import { Instant, Now } from 'temporal-luxon';
// TODO Remove this method and refactor usages once Formatters support PlainDate directly
export const toZonedDateTime = (date) => date.toZonedDateTime({
    timeZone: Now.timeZone(),
});
export const toPlainDate = (date) => {
    const instant = Instant.fromEpochMilliseconds(date.getTime());
    const timeZone = Now.timeZone();
    const zonedDateTime = instant.toZonedDateTimeISO(timeZone);
    return zonedDateTime.toPlainDate();
};
export const toDate = (plainDate) => new Date(toZonedDateTime(plainDate).epochMilliseconds);
//# sourceMappingURL=date_utils.js.map